import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import Loader from '../../../../component/common/Loader'
import { Link, useNavigate } from 'react-router-dom';
import { StatCard, STAT_ICONS } from '../../../../component/common/designSystem';
import { Api } from '../../../../api';
import RightArrow from '../../../../assets/images/sidebar/sidebar_right_arrow.svg';

const BadgesAndWellPointsPage = () => {
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const userData = JSON.parse(localStorage.getItem('userData'));
    const [dashStates, setDashStates] = useState({});

    const subAdminStatusCards = [
        <StatCard
            icon={STAT_ICONS.users}
            title={'Total Accounts'}
            value={dashStates?.totalAccounts}
        />,
        <StatCard
            icon={STAT_ICONS.completions}
            title={'Badges Created'}
            value={dashStates?.activeBadges}
        />,
        <StatCard
            icon={STAT_ICONS.personalBest}
            title={'Badges Won'}
            value={dashStates?.badgeWinnerCount}
        />
    ];

    useEffect(() => {
        const fetchDashState = async () => {
            try {
                setLoader(true);
                const response = await Api.getAdminBadgeDashboardState();
                if (response?.data?.status === 'success') {
                    setDashStates(response.data.data || {});
                }
            } catch (error) {
                console.error('fetchDashState error:', error);
            } finally {
                setLoader(false);
            }
        };

        fetchDashState();
    }, []);

    return (
      <div className="relative lg:mb-[45px]">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Badges & Wellpoints | Shoorah Admin</title>
        </Helmet>
        {loader ? <Loader /> : null}

        <div className="sm:flex flex-col md:flex-row justify-between items-center gap-3 mt-3">
          <h1 className="font-medium leading-9 text-shoorah-lightBlack dark:text-shoorah-darkBg text-2xl">
            Badges & Wellpoints
          </h1>
          {userData?.userType === 0 && (
            <div className="self-center inline-flex items-center justify-center w-64 sm:w-auto">
              <Link
                to={'/badges/active-badges/add-badge'}
                className="font-medium px-5 py-2 bg-shoorah-active text-white rounded-full xl:text-[16px] text-[14px]"
              >
                Create Badge
              </Link>
            </div>
          )}
        </div>

        {/* Stat cards */}
        <div className="grid md:grid-cols-3 grid-cols-1 h-auto gap-4 mt-5">
          {subAdminStatusCards.map((item, index) => (
            <React.Fragment key={index}>{item}</React.Fragment>
          ))}
        </div>

        {/* Active Badges navigation */}
        <div
          className="w-100 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl p-5 mt-5 flex justify-between items-center cursor-pointer"
          onClick={() => navigate('/badges/active-badges')}
        >
          <h1 className="font-medium leading-9 text-shoorah-lightBlack dark:text-shoorah-darkBg text-xl">
            Active Badges
          </h1>
          <img src={RightArrow} className="w-[30px] ml-2" alt="right_arrow" />
        </div>

        {/* B2B & B2C Users Badges navigation card */}
        <div
          className="w-100 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl p-5 mt-5 flex justify-between items-center cursor-pointer"
          onClick={() => navigate('/badges/users')}
        >
          <div className="flex flex-col">
            <h1 className="font-medium leading-9 text-shoorah-lightBlack dark:text-shoorah-darkBg text-xl">
              B2B &amp; B2C Users Badges
            </h1>
            <p className="text-sm text-gray-500 dark:text-shoorah-darkBg">
              View badges earned by B2C users and B2B company employees
            </p>
          </div>
          <img src={RightArrow} className="w-[30px] ml-2" alt="right_arrow" />
        </div>
      </div>
    );
}

export default BadgesAndWellPointsPage
